import { useBaseMutation } from "../baseMutation";
import { RemoveFolderSharingsRequest, RemoveFolderSharingsResponse } from "@maven-rest/docs/FolderSharing.dto";
import { FolderSharingRest } from "@maven-rest/docs/FolderSharing.rest";

export function useRemoveFolderSharingMutation(req: {
  onSuccess?: (data: RemoveFolderSharingsResponse, variables: RemoveFolderSharingsRequest, context: unknown) => void;
}) {
  return useBaseMutation<RemoveFolderSharingsResponse, RemoveFolderSharingsRequest>({
    mutationFn: async ({ sharingId }: RemoveFolderSharingsRequest) => {
      return await FolderSharingRest.removeFolderSharing({ sharingId });
    },
    onSuccess(data, variables, context) {
      req.onSuccess && req.onSuccess(data, variables, context);
    },
  });
}
